export default "__VITE_ASSET__DqTdne4S__"